const propTypeDeprecated = (oldPropName, newPropName) => (props, propName, componentName) => {
    if (propName === oldPropName && props[propName] !== undefined) {
        return new Error(`DEPRECATED prop '${propName}' was supplied to '${componentName}.'${newPropName && " Update to use '" + newPropName + "' instead."}`);
    }
};
export default propTypeDeprecated;
//# sourceMappingURL=propTypeDeprecated.js.map